<template>
    <div class="row">
        <div class="col-sm-9">
            <div class="step-detail step-two">
                <h1 class="line-bottom">{{ $t('2. Kies uw mechanismes')}}</h1>
                <p class="row col-sm-10">
                    {{ $t('Kies hieronder eerst uw gewenste mechanismes. Deze worden toegevoegd aan uw selectie. Klik op')}} (<span class="mdi mdi-information-outline"></span>) {{ $t('voor meer info.')}}
                </p>
                <div class="e-ext-checks" ref="checks" :style="{ height: $parent.getStepDetailHeight($refs.checks) }">
                    <div class="row">
                        <div class="col-sm-4">
                            <h2>{{ $t('Smeltlood mechanisme')}}</h2>&nbsp;<i v-if="warningMec" class="icon warning"></i>

                            <div class="info-checks-radios e-info-checks"  v-for="(mechanism, key) in orderedMecs">
                                <div v-show="false" v-if="(mechanism.type === 'MFUS(P)' || mechanism.type === 'CFTH' || mechanism.type === 'FT72-SC')">
                                    <info-check :name="mechanism.name[$i18n.locale]"
                                                :mectrans="mechanism.name"
                                                :current-value="currentValueMechanisme.id"
                                                :value="mechanism"
                                                :img-src="mechanism.picture"
                                                :id="mechanism.id"
                                                type="mechanisme"
                                                mechmotor="smeltlood"
                                                :mectype="mechanism.type"
                                                ref="smeltlood"
                                                is-radio-button="true"
                                    >
                                        <p>{{mechanism.type}}
                                            <br>{{mechanism.name[$i18n.locale]}}
                                            <br>{{mechanism.omschrijving}}
                                        </p>
                                    </info-check>
                                    <!--<br>-->
                                </div>
                            </div>
<!--                            <br>
                            <hr>-->
                            <template v-for="(mechanism, key) in mechanismes">
<!--                                <div  class="icon-title">
                                    <h2>{{ $t('Varianten voor')}} {{mechanism.name[$i18n.locale]}}</h2>&nbsp;<i v-if="warningVariant" class="icon warning"></i>
                                </div>
                                <br>-->
                                <div class="info-checks-radios e-info-checks"  v-for="(variant, key) in mechanism.variants">
                                    <div v-if="(mechanism.type === 'MFUS(P)' || mechanism.type === 'CFTH' || mechanism.type === 'FT72-SC')">
                                        <info-check
                                                :name="variant.name[$i18n.locale]"
                                                :vartrans="variant.name"
                                                :current-value="currentValueVariant.id"
                                                :value="variant"
                                                :img-src="variant.picture"
                                                :id="variant.id"
                                                :price="variant.price"
                                                :info="variant.info[$i18n.locale]"
                                                type="variant"
                                                mechmotor="smeltlood"
                                                :code="variant.code"
                                                :standard-checked="standardVariant"
                                                :mechanism-id="mechanism.id"
                                                :mechanism-name="mechanism.name[$i18n.locale]"
                                                :mectype="mechanism.type"
                                                :mectrans="mechanism.name"
                                                ref="smeltloodv"
                                                is-radio-button="true"
                                        >
                                            <p>{{variant.code}}<br>{{variant.name[$i18n.locale]}}</p>
                                            <p>{{variant.omschrijving}}
                                            </p>
                                        </info-check>
                                        <br>
                                    </div>
                                </div>
                            </template>
                            <template v-for="(mechanism, key) in mechanismes" v-show="Mechanisme.name !== undefined && Mechanisme.mectype === mechanism.type && (mechanism.type === 'MFUS(P)' || mechanism.type === 'CFTH' || mechanism.type === 'FT72-SC')">
                                <template v-for="variant in mechanism.variants" v-show="Variant.name !== undefined" v-if="variant.models.length !== 0">
                                    <div class="icon-title" v-show="Variant.id === variant.id && (mechanism.type === 'MFUS(P)' || mechanism.type === 'CFTH' || mechanism.type === 'FT72-SC')">
                                        <h2>{{ $t('Opties voor')}} {{variant.name[$i18n.locale]}}</h2>
                                    </div>
                                    <br>
                                    <div class="info-checks-radios e-info-checks"  v-for="(option, key) in variant.models">
                                        <div  v-show="variant.id === Variant.id && (mechanism.type === 'MFUS(P)' || mechanism.type === 'CFTH' || mechanism.type === 'FT72-SC')">
                                            <info-check
                                                    :name="option.info[$i18n.locale]"
                                                    :mectrans="option.info"
                                                    :value="option"
                                                    :current-value="currentValueOption.id"
                                                    :id="option.id"
                                                    :price="option.price"
                                                    :info="option.info[$i18n.locale]"
                                                    type="option"
                                                    mechmotor="smeltlood"
                                                    is-radio-button="true"
                                                    :code="option.value">
                                                <p>{{option.value}}<br>{{option.info[$i18n.locale]}}</p>
                                            </info-check>
                                            <br>
                                        </div>
                                    </div>
                                </template>
                            </template>
                        </div>

                        <div class="col-sm-8">
                            <h2>{{ $t('Gemotoriseerd mechanisme')}}</h2>&nbsp;<i v-if="warningMec" class="icon warning"></i>
                            <div class="info-checks-radios e-info-checks"  v-for="(mechanism, key) in orderedMecs">
                                <div v-if="(mechanism.type !== 'MFUS(P)' &&  mechanism.type !== 'CFTH' &&  mechanism.type !== 'FT72-SC')">
                                    <info-check
                                            :name="mechanism.name[$i18n.locale]"
                                            :mectrans="mechanism.name"
                                            :current-value="currentValueMechanisme.id"
                                            :value="mechanism"
                                            :img-src="mechanism.picture"
                                            :id="mechanism.id"
                                            type="mechanisme"
                                            mechmotor="gemotoriseerd"
                                            is-radio-button="true"
                                            :mectype="mechanism.type">
                                        <p>{{mechanism.type}}
                                            <br>{{mechanism.name[$i18n.locale]}}
                                            <br>{{mechanism.omschrijving}}
                                        </p>
                                    </info-check>
                                    <br>
                                </div>
                            </div>
                            <br>
                            <hr>
                            <template v-for="(mechanism, key) in mechanismes">
                                <div class="icon-title" v-show="Mechanisme.name !== undefined && Mechanisme.mectype === mechanism.type && (mechanism.type !== 'MFUS(P)' &&  mechanism.type !== 'CFTH' &&  mechanism.type !== 'FT72-SC')">
                                    <h2>{{ $t('Varianten voor')}} {{mechanism.name[$i18n.locale]}}</h2>&nbsp;<i v-if="warningVariant" class="icon warning"></i>
                                </div>
                                <br>
                                <div class="info-checks-radios e-info-checks"  v-for="(variant, key) in mechanism.variants">
                                    <div v-show="mechanism.id === Mechanisme.id && Mechanisme.name !== undefined && Mechanisme.mectype === mechanism.type && (mechanism.type !== 'MFUS(P)' &&  mechanism.type !== 'CFTH' &&  mechanism.type !== 'FT72-SC')">
                                        <info-check
                                                :name="variant.name[$i18n.locale]"
                                                :value="variant"
                                                :vartrans="variant.name"
                                                :current-value="currentValueVariant.id"
                                                :img-src="variant.picture"
                                                :id="variant.id"
                                                :price="variant.price"
                                                :info="variant.info[$i18n.locale]"
                                                type="variant"
                                                mechmotor="gemotoriseerd"
                                                :code="variant.code"
                                                :mechanism-id="mechanism.id"
                                                :mechanism-name="mechanism.name[$i18n.locale]"
                                                :mectype="mechanism.type"
                                                :mectrans="mechanism.name"
                                                is-radio-button="true"
                                        >
                                            <p>{{variant.code}}<br>{{variant.name[$i18n.locale]}}</p>
                                            <p>{{variant.omschrijving}}
                                            </p>
                                        </info-check>
                                        <br>
                                    </div>
                                </div>
                            </template>
                            <template v-for="(mechanism, key) in mechanismes" v-show="Mechanisme.name !== undefined && Mechanisme.mectype === mechanism.type && (mechanism.type !== 'MFUS(P)' &&  mechanism.type !== 'CFTH' &&  mechanism.type !== 'FT72-SC')">
                                <template v-for="variant in mechanism.variants" v-show="Variant.name !== undefined" v-if="variant.models.length !== 0">
                                    <div class="icon-title" v-show="Variant.id === variant.id && (mechanism.type !== 'MFUS(P)' &&  mechanism.type !== 'CFTH' &&  mechanism.type !== 'FT72-SC')">
                                        <h2>{{ $t('Opties voor')}} {{variant.name[$i18n.locale]}}</h2>
                                    </div>
                                    <br>
                                    <div class="info-checks-radios e-info-checks"  v-for="(option, key) in variant.models">
                                        <div  v-show="variant.id === Variant.id && Mechanisme.mectype === mechanism.type && (mechanism.type !== 'MFUS(P)' &&  mechanism.type !== 'CFTH' &&  mechanism.type !== 'FT72-SC')">
                                            <info-check
                                                    :name="option.info[$i18n.locale]"
                                                    :mectrans="option.info"
                                                    :value="option"
                                                    :current-value="currentValueOption.id"
                                                    :id="option.id"
                                                    :price="option.price"
                                                    :info="option.info[$i18n.locale]"
                                                    type="option"
                                                    mechmotor="gemotoriseerd"
                                                    :code="option.value">
                                                <p>{{option.value}}<br>{{option.info[$i18n.locale]}}</p>
                                            </info-check>
                                            <br>
                                        </div>
                                    </div>
                                </template>
                            </template>
                        </div>
                    </div>
                </div>

            </div>
        </div>


        <div class="col-sm-3" ref="yourSelectionWrapper" :style="{ height: $parent.getStepDetailHeight($refs.yourSelectionWrapper, false) }">
            <div class="your-selection col-sm-12">
                <div class="block title">
                    <p>{{ $t('Uw selectie')}}</p>
                </div>
                <div class="block">
                    <div class="prices">
                        <div class="line">
                            <div>{{StepOne.sku}}</div>
                            <div>&euro; {{StepOne.price}}</div>
                        </div>
                    </div>

                </div>
                <div class="block" v-show="selectedMechanism.name !== undefined">
                    <p>{{selectedMechanism.mectype}}&nbsp;{{selectedMechanism.name}}</p>
                </div>

                <div class="block" v-if="selectedVariant.price !== undefined">
                    <p>{{ $t('Variant')}}</p>
                    <div class="prices">
                        <div class="line">
                            <div class="info">{{selectedVariant.code}}&nbsp;{{selectedVariant.name}}</div>
                            <div>&euro; {{selectedVariant.price}}</div>
                        </div>
                    </div>
                </div>
                <div class="block" v-if="selectedOption.price !== undefined">
                    <p>{{ $t('Option')}}</p>
                    <div class="prices">
                        <div class="line" >
                            <div class="info">{{selectedOption.code}}&nbsp;{{selectedOption.parent}}</div>
                            <div>&euro; {{selectedOption.price}}</div>
                        </div>
                    </div>
                </div>

                <div class="block total">
                    <p>{{ $t('Totaal')}}</p>
                    <p>&euro; {{total}}</p>

                </div>
                <div class="block">
                  <p class="font-weight-normal">{{ $t('prijs_informatie')}}</p>
                  <p class="font-weight-normal">{{ $t('prijs_informatie2')}}</p>
                </div>
                <button class="btn primary icon check disabled" style="background-color:#686868" v-if="((!isSC) && (selectedMechanism.name === undefined || selectedVariant.name === undefined))" @click="nextStep(false)">
                    {{ $t('OK, kies Opties en kaders')}}
                </button>
                <router-link to="/stepthree" v-else="((isSC) || ((selectedMechanism.name !== undefined && selectedVariant.name !== undefined) && (selectedMechanism.name !== '' && selectedVariant.name !== '')))" @click="nextStep(true)">
                    <button class="btn primary icon check">
                      {{ $t('OK, kies Opties en kaders')}}
                    </button>
                </router-link>
                <div class="clearfix">&nbsp;</div>
                <div class="clearfix">&nbsp;</div>
                <p style="color:#FF0000;text-align: right" v-if="warning !== ''" v-html="warning"></p>
                <!--<button class="btn primary icon check">-->
                <!--Okee, ga verder-->
                <!--</button>-->
            </div>
        </div>
    </div>
</template>

<script>
  import Checkbox from '../components/elements/Checkbox'
  import SquareCheckbox from '../components/elements/SquareCheckbox'
  import Between from '../components/elements/Between'
  import ProductOverviewItem from '../components/elements/ProductOverviewItem'
  import InfoCheck from '../components/elements/InfoCheck'
  import InfoRadios from '../components/elements/InfoRadios'
  import InfoRadio from '../components/elements/InfoRadio'
  import { EventBus} from '../services/eventBus'
  import apiService from '../services/request'
  import VueLodash from 'vue-lodash'
  import Vue from 'vue'

  export default {
    name: 'StepTwo',
    components: {
      'checkbox': Checkbox,
      'square-checkbox': SquareCheckbox,
      'between': Between,
      'product-overview-item': ProductOverviewItem,
      'info-check': InfoCheck,
      'info-radio': InfoRadio,
      'info-radios': InfoRadios
    },
    data () {
      return {
        total: 0,
        StepOne: '',
        selection: {},
        Mechanisme: {},
        Variant: {},
        Option: {},
        ids: [],
        currentValueMechanisme: {},
        currentValueVariant: {},
        currentValueOption: {},
        prices: [{name: 'ONE 24 FDCU', value: 113.15}, {name: 'IXI R1', value: 23.15}, {name: 'FDCU', value: 428.95}],
        mechanismes: {},
        warning: '',
        warningVariant: false,
        warningMec: false,
        standardVariant: false,
        isSC: false,
      }
    },
    methods: {
      firstClick() {
          alert('first click')
      },
      isEmpty(obj) {
      for(var key in obj) {
        if(obj.hasOwnProperty(key)) {
            return false;
        }
      }
      return true;
    },
      getMechanisms () {
        this.StepOne = Vue.ls.get('StepOne')
        //console.log(this.StepOne)
        apiService.getMechanisms(this.StepOne.id, 'nl-be' , this.setMechanisms)
      },
      setMechanisms (response) {
        this.mechanismes = response
      },
      setMechanisme (selected) {
        //console.log(this.mechanismes[selected.id])
        this.standardVariant = this.mechanismes[selected.id].variants.length === 1; //ml: if only one variant for this mech, make it active
        //this.Variant = {}
        //this.Option = {}
        this.Mechanisme = selected
        //this.currentValueVariant = {}
        //this.currentValueOption = {}
        this.warning = ''
        this.warningMec = false
        if (selected.checked === false) {
          this.Mechanisme = {}
        }
        this.setSelected(this.Mechanisme, 'mechanisme')
      },
      setVariant (selected) {
        //this.Option = {}
        //this.currentValueOption = {}
        this.warning = ''
        this.warningVariant = false
        this.Variant = selected
        if (selected.checked === false) {
          this.Variant = {}
        }
        this.setSelected(this.Variant, 'variant')
      },
      setOption (selected) {
          this.Option = selected
        if (selected.checked === false) {
          this.Option = {}

        }
        this.setSelected(this.Option, 'option')
      },
      setSelected (object, type) {
        this.selection[type] = object
        //console.log('seleccionado')
        //console.log(this.selection)
        //Vue.ls.set('StepTwo', {})
        Vue.ls.set('StepTwo', this.selection)

        this.getTotal()
      },
      nextStep(bool) {
        if(bool) {
          this.warning = ''
        } else {
          this.warning = ''
          if(this.selectedMechanism.name === undefined || this.selectedMechanism.name === ''){
            this.warning += this.$t('Please select a mechanism!') + '<br/>'
            this.warningMec = true
          }
          if(this.selectedVariant.name === undefined || this.selectedVariant.name === ''){
            this.warning += this.$t('Please select a variant!')+ '<br/>'
            this.warningVariant = true
          }
        }
      },
      getTotal () {
        this.total = this.StepOne.price
        if(this.Variant.price !== undefined && this.Option.price === undefined) {
          this.total = Math.round((parseFloat(this.StepOne.price) + this.Variant.price) * 1e12) / 1e12
        }
        if(this.Variant.price !== undefined && this.Option.price !== undefined) {
          this.total = Math.round((parseFloat(this.StepOne.price) + this.Variant.price + this.Option.price) * 1e12) / 1e12
        }
        this.total = Math.round(this.total * 100) / 100
      }
    },
    computed: {

      selectedMechanism: function () {
        return this.Mechanisme
      },
      selectedVariant: function () {
        return this.Variant
      },
      selectedOption: function () {
        return this.Option
      },
      orderedMecs: function () {
        return _.orderBy(this.mechanismes, 'sortsequence')
      }
    },
    beforeDestroy: function () {
      EventBus.$off('radio-button::new-value')
    },
    mounted: function () {
        if (Vue.ls.get('StepTwo') !== null) {
            let currentSelect = Vue.ls.get('StepTwo')
/*            console.log('currentSelect')
            console.log(currentSelect)*/
            if (typeof currentSelect['mechanisme'] !== 'undefined') {
                this.currentValueMechanisme = currentSelect['mechanisme']
                this.Mechanisme = currentSelect['mechanisme']
                this.setSelected(currentSelect['mechanisme'], 'mechanisme')
                //EventBus.$emit('MechSelected', this.currentValueMechanisme);
            }

            if (typeof currentSelect['variant'] !== 'undefined') {
                this.currentValueVariant = currentSelect['variant']
                this.Variant = currentSelect['variant']
                this.setSelected(currentSelect['variant'], 'variant')
                //EventBus.$emit('VariantSelected', this.currentValueVariant);
            }

            if (typeof currentSelect['option'] !== 'undefined') {
                //console.log(currentSelect['option'])
                this.currentValueOption = currentSelect['option']
                this.Option = currentSelect['option']
                this.setSelected(currentSelect['option'], 'option')
                //EventBus.$emit('OptionSelected', this.currentValueOption);
            }
            //console.log(currentSelect['mechanisme'])
        }
        //console.log('route query')
        //console.log(this.$route.query)
        if (this.$route.query.newproduct !== undefined) {
            Vue.ls.set("newConf", true)
            this.$router.push({name: 'StepThree'})
        } else if (this.$route.query.samemec !== undefined){
            Vue.ls.set("newConf", true)
            this.$router.push({name: 'StepThree'})
        } else if (this.$route.query.sameproduct !== undefined) {
            Vue.ls.set("newConf", true)
            //Vue.ls.remove('StepTwo')
        } else {
            Vue.ls.set("newConf", false)
            //Vue.ls.remove('StepTwo')
        }

        EventBus.$emit('routeChange')
        if(Vue.ls.get('StepOne') === null) {
            this.$router.push({name: 'StepOne'})
        } else {
            let strSku = Vue.ls.get('StepOne').sku;
            var res = strSku.substring(0, 2);
            //alert(res)
            if (res === 'SC') {
                this.isSC = true
                Vue.ls.set('StepTwo', {})
            }
        }
      EventBus.$on('radio-button::new-value', function(value, type) {
        if (type == 'mechanisme' ) {
          this.currentValueMechanisme = value;
          this.currentValueVariant = {};
          this.currentValueOption = {};
        }
        if (type == 'variant' ) {
          this.currentValueVariant = value;
        }
        if (type == 'option' ) {
          this.currentValueOption = value;
        }
      }.bind(this))
      EventBus.$on('MechSelected', this.setMechanisme)
      EventBus.$on('VariantSelected', this.setVariant)
      EventBus.$on('OptionSelected', this.setOption)
      this.getMechanisms()

      this.getTotal();
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>




// WEBPACK FOOTER //
// src/views/StepTwo.vue